<script>
  /* Copyright (c) 2020 Jacques Desodt */
  import Item from './Item.svelte'
  import { getAmPm, hourToDegrees } from '../scripts/dates'

  export let args
  export let date
  /* Local variables */
  let degrees = [ 300, 330, 0, 30, 60, 90, 120, 150, 180, 210, 240, 270 ]
  $: selectedAmpm = args.is24h ? getAmPm(date) : 'am'
  $: selectedDegrees = hourToDegrees(date)
</script>

<!-- AM -->
{#each degrees as item, index}
<Item ampm="am" degrees={item} {selectedAmpm} {selectedDegrees} label="{index + 1}" />
{/each}
<!-- PM -->
{#if args.is24h}
  {#each degrees as item, index}
<Item ampm="pm" degrees={item} {selectedAmpm} {selectedDegrees} label="{index === 11 ? 0 : index + 1 + 12}" />
  {/each}
{/if}
